import { alpha, Box, styled } from "@mui/material";
import { colors } from "../../styles/theme";
import { BREAKPOINT_MOBILE, FRAME_BORDER_WIDTH } from "../../constants";
import { convertToBreakpoints, getFluidsByKeys } from "../../utils/fuilds";
import { IconRotate } from "../Icons/Icons";
import { deviceStyles } from "../../hooks/useDeviceStyles";

export const StyledApp = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  position: "relative",
  background: colors.background.v1,
  // dvh tracks the visible viewport; grows when Safari's bars collapse
  height: "100dvh",
  //height: "100%",

  // width: '100%',
  // minHeight: 'calc(100dvh - var(--menu-h))',
  // paddingTop: 'env(safe-area-inset-top)',

  // height: "100vh",
  // ...deviceStyles({
  //   desktop: {
  //     padding: "40px 75px",
  //   }
  // }),
  ...convertToBreakpoints(theme, {
    xs: {
      padding: 0,
    },
    lg: {
      padding: "20px 38px",
    },
    xxxl: {
      padding: "40px 75px",
    },
  }),
  "& > *": {
    lineHeight: 1,
  },
  "&::after": {
    content: "''",
    position: "absolute",
    top: 0,
    bottom: 0,
    left: "50%",
    width: "1px",
    height: "100%",
    transform: "translateX(-50%)",
    // background: "red", /* @TODO temp */
    opacity: 0.1,
  },
}));

export const StyledBorderFrame = styled(Box)(({ theme }) => ({
  border: `solid ${colors.text.v1}`,
  borderTop: "none",
  [theme.breakpoints.down(BREAKPOINT_MOBILE)]: {
    borderLeft: "none",
    borderRight: "none",
    borderBottom: "none",
  },
  [theme.breakpoints.up(BREAKPOINT_MOBILE)]: {
    "&::after": {
      display: "none",
    },
  },
  ...convertToBreakpoints(theme, {
    xs: {
      // borderWidth: `${FRAME_BORDER_WIDTH.xs}px`,
      // padding: '5px',
      // paddingBottom: '5px',
    },
    md: {
      // borderWidth: `${FRAME_BORDER_WIDTH.md}px`,
      // padding: '10px',
      // paddingBottom: '10px',
    },
    xxl: {
      padding: "15px",
    },
    xxxl: {
      borderWidth: `${FRAME_BORDER_WIDTH.xxxl}px`,
      padding: "24px",
    },
  }),
  "&::before, &::after": {
    content: "''",
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    background: `linear-gradient(
            to right,
            ${alpha(colors.text.v1, 1)} 0%,
            ${alpha(colors.text.v1, 0.2)} 30%,
            ${alpha(colors.text.v1, 0)} 50%,
            ${alpha(colors.text.v1, 0.2)} 70%,
            ${alpha(colors.text.v1, 1)} 100%
          )`,
    zIndex: 99 /* 2 */,
    ...convertToBreakpoints(theme, {
      xs: {
        height: `${FRAME_BORDER_WIDTH.xs}px`,
      },
      lg: {
        height: `${FRAME_BORDER_WIDTH.lg}px`,
      },
      xxxl: {
        height: `${FRAME_BORDER_WIDTH.xxxl}px`,
      },
    }),
  },
  "&::before": {
    top: 0,
  },
  "&::after": {
    bottom: 0,
  },
}));

export const StyledVideoWrapper = styled(StyledBorderFrame)(({ theme }) => ({
  position: "relative",
  flexGrow: 1,
  flexBasis: 0, // ✅ IMPORTANT
  minHeight: 0,
  width: "100%", // ✅ ensures proper sizing
  overflow: "hidden",
  background: colors.background.v1,

  [theme.breakpoints.down(BREAKPOINT_MOBILE)]: {
    border: "none",
  },
}));

export const StyledIconRotate = styled(IconRotate)(({ theme }) => ({
  fontSize: "6.5vh",
  color: colors.text.v4,
}));

export const RotatingBox = styled(Box)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  transformOrigin: "50% 50%",
  animation: "rotatePhone 2.5s ease-in-out infinite",
  "@keyframes rotatePhone": {
    "0%": {
      transform: "rotate(0deg)",
    },
    "40%": {
      transform: "rotate(-45deg)",
    },
    "70%": {
      transform: "rotate(-45deg)",
    },
    "100%": {
      transform: "rotate(0deg)",
    },
  },
  ...convertToBreakpoints(theme, {
    xs: { marginTop: "30px" },
    md: { marginTop: "8.65vh" },
  }),
}));
